export default __webpack_public_path__ + "static/media/factory__15.8251a5dd.jpg";